import { useDeleteBooking } from "$api/client";
import { Button, Popconfirm } from "antd";

const DeleteBooking = ({ crm_dealercode, date, team, closeModal }) => {
  const deleteBooking = useDeleteBooking(crm_dealercode, date, team);

  const onClick = () => {
    deleteBooking.mutate();
    closeModal();
  };

  return (
    <Popconfirm
      title="Buchung stornieren"
      description="Sind Sie sicher, dass Sie diese Buchung stornieren möchten?"
      okText="Ja"
      cancelText="Nein"
      onConfirm={onClick}
    >
      <Button
        key="deleteAppointment"
        type="primary"
        size="large"
        htmlType="submit"
        danger
      >
        Buchung stornieren
      </Button>
    </Popconfirm>
  );
};

export default DeleteBooking;
